import { TextField as MuiTextField } from '@mui/material';
import { forwardRef } from 'react';

const TextField = (props, ref) => {
  return <MuiTextField {...props} ref={ref} />;
};

export default forwardRef(TextField);
